export const arrayWithUniqueValues = <T extends unknown[]>(arr: T): T => [...new Set(arr)] as T;

/**
 * Returns a new array that contains only unique
 * items of the source array.
 */
export function distinctArray<T>(array: Iterable<T>, keyGetter?: (elem: T) => string | number): T[] {
  if (array instanceof Set) {
    return Array.from(array);
  }

  if (!keyGetter) {
    return [...new Set(array)];
  }

  const result = [] as T[];
  const usedKeys = new Set<string | number>();

  for (const e of array) {
    const key = keyGetter(e);
    if (!usedKeys.has(key)) {
      usedKeys.add(key);
      result.push(e);
    }
  }

  return result;
}
export function getArrayMinMax(array: string[]) {
  let minV = array[0];
  let maxV = array[0];

  for (const item of array) {
    if (item < minV) minV = item;
    if (item > maxV) maxV = item;
  }

  return [minV, maxV];
}
